/**
 * Warehouse Insights API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TimelineEvent } from './timelineEvent';


/**
 * A chronological list of past occurrences of this insight, used in the History tab to show how the situation has evolved over time.
 */
export interface TimelineBlock { 
    /**
     * Discriminator identifying this block as a timeline.
     */
    type?: TimelineBlock.TypeEnum;
    /**
     * Heading for the timeline, for example \'Previous instances of this insight\'.
     */
    title: string;
    /**
     * Ordered timeline events, typically most recent first.
     */
    events: Array<TimelineEvent>;
}
export namespace TimelineBlock {
    export const TypeEnum = {
        Timeline: 'timeline'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


